import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import {PageTop, TitleH1, Title, SidebarNews, InfoBlock, Main, Content, Row, Col2 } from '../layouts/layouts'
import SideBarRight from '../layouts/SideBarRight'

import img from '../assets/viljapelto2-490x368-2256.jpg'


class Psykoterapia extends React.Component {

  render() {
    return (
      <div>
        <Helmet>
          <title>Kirsti Louko - Työnohjaus</title>
        </Helmet>
        <PageTop>
          <TitleH1>TYÖNOHJAUS</TitleH1>
          <p>Työnohjaus on oman työn tutkimista, arviointia ja kehittämistä, joka tapahtuu koulutetun työnohjaajan avulla.​​</p>
        </PageTop>
        <Content>
          <SideBarRight view="tyonohjaus"/>
          <Main column>
            <p>Työnohjaus on työhön, työyhteisöön ja omaan työrooliin liittyvien kysymysten, kokemusten ja tunteiden yhdessä tulkitsemista ja jäsentämistä.</p>
            <p>Työnohjauksessa ohjattava pohtii suhdetta työhönsä. Ohjaaja ja mahdolliset muut osallistujat auttavat ohjattavaa näkemään itsensä ja työnsä entistä tarkemmin ja selvemmin.</p>
            <p>Työnohjaus on vuorovaikutusta, jossa sekä ohjaaja että ohjattavat oppivat toisiltaan.</p>
            <p>Työnohjaus auttaa jaksamaan työssä ja pysymään työkykyisenä.</p>
            <p>Työnohjauksessa käytän ratkaisukeskeisiä menetelmiä. Työnohjaus räätälöidään asiakkaan tarpeenmukaisesti.</p>
            <p>Hinnat sovitaan asiakkaan kanssa toimeksiannon laajuudesta riippuen.</p>
            <p style={{textAlign: 'center'}}>
              <img src={img}/>
            </p>
          </Main>
        </Content>

      </div>
    )
  }
}

export default Psykoterapia;



// WEBPACK FOOTER //
// ./src/pages/tyonohjaus.js